module.exports = "@import &#x27;../variables&#x27;; .TransportationModesPane { padding-top: 20px; .CheckboxControl { @include not-mobile { margin-right: 20px; margin-bottom: 20px; min-width: 200px; &amp;:last-child { margin-right: 0; } } @include mobile { display: block; &amp;+.CheckboxControl { margin-top: 1em; } } } }"


//////////////////
// WEBPACK FOOTER
// ./~/svg-inline-loader!./client/components/ParametersScreen/TransportationModesPane.scss
// module id = 2026
// module chunks = 0